<!-- <p>floating-icon works!</p> -->
<div
  [ngClass]="{
    'floating-icon-container':
      screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
    'floating-icon-container-mobile': screenInfo == ScreenType.Mobile
  }"
>
  <button mat-fab (click)="toggleMenu()" [matMenuTriggerFor]="actionMenu">
    <mat-icon>add_circle</mat-icon>
  </button>
  <div class="mat-menu-container">
    <mat-menu yPosition="above" #actionMenu="matMenu">
      <button
        [disabled]="isDisableFeature"
        mat-menu-item
        (click)="clickedRaiseRequest()"
        *ngIf="!isNative"
      >
        <span
          >Request SOS
          <sub *ngIf="screenInfo != ScreenType.Mobile && false"
            ><i>switch to mobile</i></sub
          >
        </span>
      </button>
      <button mat-menu-item (click)="clickedNoticeBoard()">
        <span>Write Notice Post</span>
      </button>
      <!-- <button [disabled]="true" mat-menu-item>
        <span
          >Book time slot <sub><i>coming soon</i></sub></span
        >
      </button> -->
      <!-- <button [disabled]="true" mat-menu-item>
        <span
          >Make a payment <sub><i>coming soon</i></sub></span
        >
      </button>
      <button [disabled]="true" mat-menu-item>
        <span
          >Sell item <sub><i>coming soon</i></sub></span
        >
      </button> -->
      <button mat-menu-item (click)="clickedManageVisitorPass()">
        <span>Manage Visitor Pass </span>
      </button>
      <!-- <button [disabled]="true" mat-menu-item>
        <span
          >Pay EMI <sub><i>coming soon</i></sub></span
        >
      </button>
      <button [disabled]="true" mat-menu-item>
        <span
          >Recharge <sub><i>coming soon</i></sub></span
        >
      </button> -->
      <!-- <button [disabled]="true" mat-menu-item>
        <span
          >Book Travel<sub><i>coming soon</i></sub></span
        >
      </button>
      <button [disabled]="true" mat-menu-item>
        <span
          >Buy Insurance<sub><i>coming soon</i></sub></span
        >
      </button> -->
      <button mat-menu-item (click)="clickedVisitorLogbook()">
        <span>Visitors Logbook </span>
      </button>
      <button mat-menu-item (click)="clickedMyLists()" *ngIf="!isNative">
        <span>{{ "My Lists" }}</span>
      </button>
      <!-- Add more menu items as needed -->
    </mat-menu>
  </div>
</div>
